import { Box, Collapse, IconButton, Typography } from "@material-ui/core";
import React, { ReactNode } from "react";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

const FAQItem: React.FC<{title:string, text:ReactNode}> = ({title, text}) => {

    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
      setOpen(!open);
    };
  
    return (
        <Box style={{width: '100%', borderBottom: '1px solid #ffffff'}}>
            <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'baseline', cursor: 'pointer'}} onClick={handleClick}>
                <Box component="span" style={{flexGrow:1, paddingTop: 8, paddingBottom: 8}}>
                    <Typography color='primary' variant='h5' style={{ textAlign: 'left', paddingTop: 20}}>{title}</Typography>
                </Box>
                <Box>
                    <IconButton onClick={handleClick}>{open ? <ExpandLessIcon color='primary'/> : <ExpandMoreIcon color='primary'/>}</IconButton>
                </Box>
            </Box>
            <Collapse in={open}>
                <Typography color='primary' variant='body2' style={{ textAlign: 'left', paddingTop: 20, paddingBottom: 20}}>
                    {text}
                </Typography>
            </Collapse>
        </Box>
    );
}

export default FAQItem;